import React from 'react'
import { Carousel, Button } from "react-bootstrap";
import heroImage from "../img/software-hero.jpg";
import { useNavigate } from 'react-router-dom';
function HeroSlider() {
    const navigate = useNavigate();
    return (
        <Carousel fade controls={false} indicators={false} interval={null}>
            <Carousel.Item>
                <div className="hero-slide" style={{ backgroundImage: `url(${heroImage})`, }}>
                    <div className="hero-overlay"></div>
                    <div className="hero-content">
                        <h1>
                            Transforming Ideas Into{" "}
                            <span>Powerful Software</span>
                        </h1>
                        <h2>Building Software That Drives Real Business Growth</h2>
                        <p>
                            We build scalable software, AI, ERP, web, cloud and mobile solutions
                            designed around your business needs.
                        </p>
                        
                        <div className="hero-buttons">
                            <Button className="btn-orange" onClick={() => navigate('/contactus')}>
                                Get Started
                            </Button>

                            <Button className="btn-outline-light" onClick={() => navigate('/services')}>
                                Our Services
                            </Button>
                        </div>
                    </div>
                </div>
            </Carousel.Item>

            {/* <Carousel.Item>
                <div className="hero-slide second-slide">
                    <div className="hero-content">
                        <h1>
                            Software Built Around{" "}
                            <span>Your Business</span>
                        </h1>

                        <p>
                            From ERP systems to modern web applications, we create
                            technology that solves real business problems.
                        </p>
                        <p>
                            Whether you’re a startup, small business, or growing enterprise,
                            we work closely with you to understand your requirements and deliver solutions that create measurable value
                        </p>
                        <Button className="btn-orange">
                            Explore Solutions
                        </Button>
                    </div>
                </div>
            </Carousel.Item> */}
        </Carousel>
    )
}

export default HeroSlider
